export abstract class AbstractAuthService {
  isAuthCorePackage: boolean
}
